module.exports = __webpack_public_path__ + "img/a5efd8d2-571d-406d-9a01-f30581d4ea3b.9efb94df.webp";